import ImageListComponent from "components/admin/ImageList";

const ImageListPage = () => {
  return (
    <div style={{flex: 'auto', height: '100vh', overflow: 'scroll'}} className="">
      <ImageListComponent />
    </div>
  );
};

export default ImageListPage;
